import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useState, useRef, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';
import _Heading from '../Heading/index.js';
import _Button from '../Button/index.js';

var _templateObject, _templateObject2, _templateObject3;
var StyledSlideout = withDefaultTheme(styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: 999;\n  display: block;\n  box-shadow:  ", ";\n  border: ", ";\n  position: ", ";\n  top: ", ";\n  background-color:  ", "};\n  padding: 1.75rem;\n  max-width: 400px;\n  font-size: 1.125rem;\n  font-weight: 300;\n  color:  ", ";\n\n  &[data-open='true'] {\n    right: 0;\n  }\n  &[data-open='false'] {\n    right: -400px;\n  }\n\n  transition: right 0.75s;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.boxShadow.box);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.border.size.small, " solid ").concat(theme.palette.grayLight);
}, function (_ref3) {
  var inline = _ref3.inline;
  return !inline ? 'fixed' : 'absolute';
}, function (_ref4) {
  var inline = _ref4.inline;
  return !inline ? '0' : 'auto';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.gray;
}));
var StyledExitButton = styled(_Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 1.5rem;\n  right: 1rem;\n  padding: 0.5rem;\n\n  &:hover,\n  &:active,\n  &:focus {\n    padding: 0.5rem !important;\n  }\n\n  &:active,\n  &:focus {\n    box-shadow: 0 0 0.25rem 0.1rem ", ";\n  }\n\n  i {\n    color: ", " !important;\n  }\n"])), themes.secureSite.palette.secondary, themes.secureSite.palette.gray);
var StyledHeading = styled(_Heading)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 0 !important;\n  margin-bottom: 0.5rem;\n"])));
var Slideout = function Slideout(_ref7) {
  var heading = _ref7.heading,
    _ref7$isOpenOverride = _ref7.isOpenOverride,
    isOpenOverride = _ref7$isOpenOverride === void 0 ? false : _ref7$isOpenOverride,
    setIsOpenOverride = _ref7.setIsOpenOverride,
    _ref7$hideButton = _ref7.hideButton,
    hideButton = _ref7$hideButton === void 0 ? false : _ref7$hideButton,
    _ref7$inline = _ref7.inline,
    inline = _ref7$inline === void 0 ? false : _ref7$inline,
    openButton = _ref7.openButton,
    children = _ref7.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var slideoutRef = useRef(null);
  // console.error('WTF IS THIS2size', theme.border.size);
  /* Will also set the Override(external) open value if made available */
  var handleSetIsOpen = function handleSetIsOpen(open) {
    setIsOpen(open);
    if (setIsOpenOverride) {
      setIsOpenOverride(open);
    }
  };
  var handleEscape = function handleEscape(e) {
    if (e.key === 'Escape') {
      handleSetIsOpen(false);
    }
  };
  var handleClick = function handleClick(e) {
    if (slideoutRef && slideoutRef.current && (slideoutRef.current.contains(e.target) || slideoutRef.current === e.target)) {
      return;
    }
    handleSetIsOpen(false);
  };
  useEffect(function () {
    if (isOpen) {
      document.addEventListener('mouseup', handleClick);
      document.addEventListener('keyup', handleEscape);
    } else {
      document.removeEventListener('mouseup', handleClick);
      document.removeEventListener('keyup', handleEscape);
    }
    return function () {
      document.removeEventListener('mouseup', handleClick);
      document.removeEventListener('keyup', handleEscape);
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideButton && /*#__PURE__*/React.createElement(_Button, {
    onClick: function onClick() {
      return handleSetIsOpen(true);
    },
    "data-testid": 'slideout-open-button'
  }, openButton), /*#__PURE__*/React.createElement(StyledSlideout, {
    style: {
      visibility: isOpen || isOpenOverride ? 'visible' : 'hidden'
    },
    open: isOpen || isOpenOverride,
    "data-open": isOpen || isOpenOverride,
    "data-testid": 'slideout',
    ref: slideoutRef,
    inline: inline
  }, /*#__PURE__*/React.createElement(StyledExitButton, {
    onClick: function onClick() {
      return handleSetIsOpen(false);
    },
    "data-testid": 'slideout-exit-button'
  }, /*#__PURE__*/React.createElement(_Icon, {
    color: 'gray',
    name: 'close-thin',
    "aria-label": "close"
  })), /*#__PURE__*/React.createElement(StyledHeading, {
    elemType: 'h1',
    elemStyle: "h2",
    color: "primary"
  }, heading), children));
};
var _Slideout = withDefaultTheme(/*#__PURE__*/memo(Slideout));

export default _Slideout;
